import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home'),
      meta: {
        title: 'EFNA爱福纳｜机器人减速机、关节包'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@/views/aboutUs'),
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/aboutUs/testingCenter',
      name: 'testingCenter',
      component: () => import('@/views/aboutUs/testingCenter'),
      meta: {
        title: '检测中心'
      }
    },
    {
      path: '/aboutUs/news',
      name: 'news',
      component: () => import('@/views/aboutUs/news'),
      meta: {
        title: '新闻与资讯'
      }
    },
    {
      path: '/productService',
      name: 'productService',
      component: () => import('@/views/productService'),
      meta: {
        title: '产品服务'
      }
    },
    {
      path: '/productService/medicalHealth',
      name:'medicalHealth',
      component: () => import('@/views/productService/medicalHealth'),
      meta: {
        title: '医疗健康解决方案'
      }
    },
    {
      path: '/productService/smartFactory',
      name:'smartFactory',
      component: () => import('@/views/productService/smartFactory'),
      meta: {
        title: '智能工厂解决方案'
      }
    },
    {
      path: '/applicationFields',
      name: 'applicationFields',
      component: () => import('@/views/applicationFields'),
      meta: {
        title: '应用领域'
      }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('@/views/contactUs'),
      meta: {
        title: '联系我们'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js